export function Base64url_decode ( str )
{
    return decodeURIComponent( atob( str ).split( '' ).map( function ( c )
    {
        return '%' + ( '00' + c.charCodeAt( 0 ).toString( 16 ) ).slice( -2 );
    } ).join( '' ) );
}


function Delay( ms )
{
    return new Promise( res => setTimeout( res, ms ) );
}
